export default [
    { title: 'L1', value: 'L1' },
    { title: 'L2', value: 'L2' },
    { title: 'L3', value: 'L3' },
    { title: 'L1, L2', value: 'L1,L2' },
    { title: 'L1, L3', value: 'L1,L3' },
    { title: 'L2, L1', value: 'L2,L1' },
    { title: 'L2, L3', value: 'L2,L3' },
    { title: 'L3, L1', value: 'L3,L1' },
    { title: 'L3, L2', value: 'L3,L2' },
    { title: 'L1, L2, L3', value: 'L1,L2,L3' },
    { title: 'L1, L3, L2', value: 'L1,L3,L2' },
    { title: 'L2, L1, L3', value: 'L2,L1,L3' },
    { title: 'L2, L3, L1', value: 'L2,L3,L1' },
    { title: 'L3, L1, L2', value: 'L3,L1,L2' },
    { title: 'L3, L2, L1', value: 'L3,L2,L1' },
    { title: 'L1L2', value: 'L1L2' },
    { title: 'L2L3', value: 'L2L3' },
    { title: 'L3L1', value: 'L3L1' },
]

export const standardPhaseOptions = [
    {
        value: 'L1',
        label: 'L1',
    },
    {
        value: 'L2',
        label: 'L2',
    },
    {
        value: 'L3',
        label: 'L3',
    },
]

export const itNetPhaseOptions = [
    {
        value: 'L1L2',
        label: 'L1L2',
    },
    {
        value: 'L2L3',
        label: 'L2L3',
    },
    {
        value: 'L3L1',
        label: 'L3L1',
    },
]

export const itNetPhaseOptionsLb = [
    {
        value: 'L1,L2,L3',
        label: 'L1,L2,L3',
    },
]
